import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getFileIconDefinition } from './helpers';

type FileIconPropsType = {
  fileType: string | null;
};

export const FileIcon: React.FC<FileIconPropsType> = ({ fileType }) => {
  const icon = getFileIconDefinition(fileType);

  return <FontAwesomeIcon icon={icon} color="#5F6368" />;
};
